import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employeur } from 'src/app/shared/models/employeur';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-employeur',
	templateUrl: './detail-employeur.component.html',
	styleUrls: ['./detail-employeur.component.scss']
})
export class DetailEmployeurComponent implements OnInit {
	employeur: Employeur;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences;
	isPlanificatrice: boolean;
	isDeletable = true;

	labelEmployeurCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	/**
	 * Index de pagination de la liste des formations d'un employeur
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	pairMissionRqEmployee: {
		missionRequest: MissionRequest;
		employeeName: string;
	}[] = [];

	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		nomStructure: new FormControl('', [
			Validators.required,
		]),
		addressStructure: new FormControl(new Address().label, [
			//Validators.maxLength(60)
		]),
		typeEntreprise: new FormControl(),
		siret: new FormControl(''),
		codeNaf: new FormControl(''),
		lastNameContact1: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		firstNameContact1: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		fonctionContact1: new FormControl(),
		telephoneContact1: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		emailContact1: new FormControl('', [Validators.email]),
		lastNameContact2: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		firstNameContact2: new FormControl('', [
			Validators.minLength(1),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		fonctionContact2: new FormControl(),
		telephoneContact2: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		emailContact2: new FormControl('', [Validators.email]),
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'employeur grâce à son id
		 */
		this.facade.employeurService.getEmployeurById(id).subscribe({
			next: (employeur: Employeur) => {
				this.employeur = employeur;
				if (this.employeur.addressStructure && this.employeur.addressStructure.label) {
					this.isAddressDefault.value = true;
				}
				this.facade.employeeService
					.getAllActiveEmployees()
					.subscribe((data) => {
						this.listEmployee = data;
					});
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/employeurs/list']);
	}

	goEdit(employeur: Employeur): void {
		const link = ['/employeurs/edit', employeur.id];
		this.router.navigate(link);
	}

	delete(employeur: Employeur): void {
		if (this.isDeletable) {
			this.facade.employeurService
				.deleteEmployeur(employeur.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();

		if (
			this.employeur.addressStructure &&
			this.employeur.addressStructure.label &&
			this.employeur.addressStructure.latitude &&
			this.employeur.addressStructure.longitude
		) {
			this.isAddressDefault.value = true;
		}
		this.isAddressSelected.value = false;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.facade.employeurService
				.updateEmployeur(this.employeur)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
}
